import('@popperjs/core').then(({ createPopper }) => {
    const userAvatarElem = document.querySelector('.user-menu .user-avatar');
    const userControlElem = document.querySelector('.user-menu .user-control');

    if (userAvatarElem && userControlElem) {
        (async() => {
            const popperOptions = {
                strategy: 'fixed',
                placement: 'bottom-start',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 15]
                        }
                    }
                ]
            };

            const userMenu = createPopper(userAvatarElem, userControlElem, popperOptions);

            const showUserMenu = async() => {
                userControlElem.setAttribute('data-show', 'true');
                await userMenu.setOptions({
                    ...popperOptions,
                    modifiers: [
                        {
                            name: 'eventListeners',
                            enabled: true 
                        }, ...popperOptions.modifiers
                    ]
                });
            };

            const hideUserMenu = async() => {
                userControlElem.removeAttribute('data-show');
                await userMenu.setOptions({
                    ...popperOptions,
                    modifiers: [
                        {
                            name: 'eventListeners',
                            enabled: false 
                        }, ...popperOptions.modifiers
                    ]
                });
            };

            userAvatarElem.addEventListener('click', (e) => {
                if (userControlElem.hasAttribute('data-show')) {
                    hideUserMenu();
                } else {
                    showUserMenu();
                }
            });
        })();
    }
});
